module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search","period":"Period","daily":"Daily","weekly":"Weekly","search_engine":"Search Engine","none":"None"},"fr":{"search":"Rechercher","period":"Fréquence","daily":"Jour","weekly":"Semaine","search_engine":"Moteur de recherche","none":"Aucun"},"de":{"search":"Forschen","period":"Frequenz","daily":"Tag","weekly":"Woche","search_engine":"Suchmaschine","none":"Keiner"}}')
  delete Component.options._Ctor
}
